import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import pic1 from '../../assets/images/pic-1.webp';
import pic2 from '../../assets/images/pic-2.webp';
import pic3 from '../../assets/images/pic-3.webp';
import pic4 from '../../assets/images/pic-4.webp';
import pic5 from '../../assets/images/pic-5.webp';
import pic6 from '../../assets/images/pic-6.webp';
import pic7 from '../../assets/images/pic-7.webp';
import BackToTop from '../../components/BackToTop/BackToTop';


const Footer: React.FC = () => {
  const instagramImages = [
    pic1,
    pic2,
    pic3,
    pic4,
    pic5,
    pic6,
  ];

  return (
    <footer className="site-footer">
      {/* Newsletter Section */}
      <div className="newsletter-section" id="newsletter">
        <h2 className="newsletter-title">
          Never Miss a Recipe!
          <svg className="title-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
        </h2>
        <p className="newsletter-sub">
          Join thousands of Famous Indian Recipes subscribers and get our best recipes delivered each week!
        </p>
        <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
          <input type="email" placeholder="Your Email Address" className="email-input" />
          <button type="submit" className="subscribe-btn">SUBSCRIBE</button>
        </form>
        <label className="terms-check">
          <input type="checkbox" />
          <span>I have read and agree to the <Link to="/terms-and-conditions">terms &amp; conditions</Link>.</span>
        </label>
      </div>

      {/* Instagram Grid */}
      <div className="instagram-grid">
        {instagramImages.map((img, i) => (
          <div className="instagram-item" key={i}>
            <img src={img} alt={`Img ${i}`} />
          </div>
        ))}

        <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="instagram-overlay">
          <p>Follow Me</p>
          <p className="ig-handle">@Instagram</p>
        </a>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-links" style={{ flex: 1 }}>
          <Link to="/terms-and-conditions">TERMS &amp; CONDITIONS</Link>
          <Link to="/privacy-policy">PRIVACY POLICY</Link>
          <Link to="/contact">CONTACT</Link>
        </div>
        
        <div style={{ flex: 1, textAlign: 'center', color: '#999', fontSize: '11px', letterSpacing: '0.5px' }}>
          &copy; 2026 Concept by Jeevan Tech
        </div>

        <div className="footer-copy" style={{ flex: 1, textAlign: 'right' }}>
          <div>Cook &amp; Write with <span className="heart">❤</span> by Loganayaki Thamilselvan.</div>
          <div>Famous Indian Recipes &copy; Copyright 2022. All rights reserved.</div>
        </div>
      </div>

      {/* Back to Top Component */}
      <BackToTop />
    </footer>
  );
};

export default Footer;
